import DeliveryMethodDetail from './LetterDataDetail';

export default DeliveryMethodDetail;



// WEBPACK FOOTER //
// ./src/scenes/LetterData/LetterDataDetail/index.ts